export default "https://assets.egbcdn.net/assets/packs/_/images/crypto-logotypes/tether-usdt-logo-eedb44499486debc5edd7af00be47a4c.png";